import { render, staticRenderFns } from "./OrderCreateForm.vue?vue&type=template&id=a57fd57c&scoped=true"
import script from "./OrderCreateForm.vue?vue&type=script&lang=js"
export * from "./OrderCreateForm.vue?vue&type=script&lang=js"
import style0 from "./OrderCreateForm.vue?vue&type=style&index=0&id=a57fd57c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57fd57c",
  null
  
)

export default component.exports